<template>
  <div class="bg-sky-900 p-1">
    <div class="p-1 text-white font-semibold">Data Settings</div>
  </div>
  <!-- <div class="my-4">
    <button class="bg-emerald-600 text-white p-4 text-xl rounded-xl">
      Download .CSV of my product data
    </button>
  </div>
  <div class="border-emerald-600 border rounded w-[max-content]">
    <div class="px-2 bg-emerald-600 text-white w-[max-content] rounded-br">
      .CSV Email Schedule
    </div>
    <div class="px-4 pb-4 pt-3">
      <div class="flex items-end mb-4">
        <span class="min-w-[max-content] mr-2">Email to:</span
        ><select class="m-0 max-w-[max-content]">
          <option disabled selected>select lab admin</option>
        </select>
      </div>
      <div class="flex items-end">
        <span class="min-w-[max-content] mr-2">Frequency:</span
        ><select class="m-0 max-w-[max-content]">
          <option>none</option>
          <option>weekly</option>
          <option>monthly</option>
        </select>
      </div>
    </div>
  </div> -->
  <div class="border-sky-900 border rounded w-[max-content] mt-4">
    <div class="px-2 bg-sky-900 text-white w-[max-content] rounded-br">
      Developer API
    </div>
    <div class="px-4 pb-4 pt-3">
      <div v-if="labKeys.length > 0" class="mb-4 flex gap-2">
        <button
          class="bg-emerald-600 text-white rounded px-4 py-2 hover:bg-emerald-700"
          @click="generateCSV"
          :disabled="generatingCSV"
        >
          {{ generatingCSV ? "Generating..." : "Generate CSV" }}
        </button>
        <button
          class="bg-sky-600 text-white rounded px-4 py-2 hover:bg-sky-700"
          @click="generateHTML"
          :disabled="generatingHTML"
        >
          {{ generatingHTML ? "Generating..." : "Generate HTML File" }}
        </button>
      </div>

      <div>
        <span class="font-semibold">URL</span>
        <div class="border-emerald-600 border rounded p-2">
          GET
          https://api.subangstrom.com/v1/productdata?api_key=YOUR_API_KEY_HERE
        </div>
      </div>

      <button
        class="mt-4 bg-sky-900 text-white rounded px-2 py-1"
        @click="createkey = true"
      >
        Create new API key
      </button>
      <div class="mt-4">
        <div class="font-semibold">API Keys</div>
        <div
          class="bg-black gap-px p-px inline-grid grid-cols-[repeat(5,max-content)] somepadding"
        >
          <div class="bg-gray-300">API Key</div>
          <div class="bg-gray-300">Created By</div>
          <div class="bg-gray-300">Last Used</div>
          <div class="bg-gray-300">IP Restriction</div>
          <div class="bg-gray-300">Delete</div>
          <template :key="index" v-for="(key, index) in labKeys">
            <div class="bg-white flex items-end">
              <span v-if="!visible[index]">
                {{ asteriskMiddle(key.apikey) }}
              </span>
              <span v-else> {{ key.apikey }} </span>

              <span
                v-if="!visible[index]"
                class="ml-2 cursor-pointer material-symbols-outlined text-emerald-600"
                @click="visible[index] = true"
              >
                visibility
              </span>
              <span
                v-else
                class="ml-2 cursor-pointer material-symbols-outlined text-gray-500"
                @click="visible[index] = false"
              >
                visibility_off
              </span>
            </div>
            <div class="bg-white">{{ key.createdBy }}</div>
            <div v-if="key.lastUsedTime" class="bg-white">
              {{ $store.state.cleanDate(key.lastUsedTime, true) }}
              <span v-if="key.lastUsedIp" class="rounded bg-gray-300 px-1">
                {{ key.lastUsedIp }}</span
              >
            </div>
            <div v-else class="bg-white">Never</div>
            <div class="bg-white">{{ key.ipRestricted || "None" }}</div>
            <div class="bg-white">
              <button
                class="bg-red-700 text-white rounded px-1"
                @click="deleteKey($event, key._id)"
              >
                Delete
              </button>
            </div>
          </template>
        </div>
        <!-- <div></div>
        <div v-if="showKey" class="border-emerald-600 border rounded p-2">
          12345
        </div>
        <div
          v-else
          class="border-emerald-600 border rounded p-2 cursor-pointer italic"
          @click="showKey = true"
        >
          CLICK TO SHOW KEY
        </div> -->
      </div>
    </div>
    <div v-if="createkey">
      <DisplayModal @ridfeedback="createkey = false">
        <div class="bg-white rounded shadow p-4">
          Provide a network IP address allowed to use this key. Leave empty if
          you do not want to restrict access.
          <input type="text" />

          <button
            class="bg-emerald-600 text-white rounded px-2 py-1 inline-block"
            @click="
              (ev) => createKey(ev, ev.currentTarget.previousSibling.value)
            "
          >
            Create Key
          </button>
        </div>
      </DisplayModal>
    </div>
  </div>
</template>
<script>
import { buildProductCsvExports } from "@/utils/productDataExports";
import { buildProductHtmlViewer } from "@/utils/productHtmlExport";

export default {
  mounted() {
    this.getLabKeys();
  },
  methods: {
    async deleteKey(ev, keyId) {
      const deleteit = confirm("Are you sure you want to delete this api key?");
      if (!deleteit) return;
      const button = ev.currentTarget;
      button.disabled = true;
      await this.$store.dispatch("deleteItem", {
        item: "keys",
        objid: keyId,
      });

      this.getLabKeys();
      button.disabled = false;
      this.createkey = false;
    },

    async createKey(ev, ipLock) {
      const button = ev.currentTarget;
      button.disabled = true;
      await this.$store.dispatch("createItem", {
        item: "keys",
        body: {
          ipLock,
        },
      });

      this.getLabKeys();
      button.disabled = false;
      this.createkey = false;
    },
    async getLabKeys() {
      const url = `${this.$store.state.hostname}/api/v1/keys`;

      const request = new Request(url, {
        credentials: "include",
        method: "GET",
        headers: { "content-type": "application/json" },
      });
      const data = await fetch(request);
      const jsondata = await data.json();
      if (jsondata.data?.data) {
        this.labKeys = jsondata.data.data;
      }
    },
    asteriskMiddle(string) {
      if (string.length === 30) {
        const middleStart = 5;
        const middleEnd = 25;
        const asterisks = "*".repeat(20);
        return (
          string.slice(0, middleStart) + asterisks + string.slice(middleEnd)
        );
      } else {
        return string.length;
      }
    },
    async fetchProductData() {
      const url = `${this.$store.state.hostname}/api/v1/dewars/productdata`;

      console.log("Fetching from URL:", url);

      try {
        const response = await fetch(url, {
          method: "POST",
          credentials: "include",
          headers: { "content-type": "application/json" },
          body: JSON.stringify({}),
        });
        console.log("Response status:", response.status);
        if (!response.ok) {
          const errorText = await response.text();
          console.error("Error response:", errorText);
          throw new Error(
            `API request failed with status ${response.status}: ${errorText}`
          );
        }
        const responseText = await response.text();
        console.log("Response text:", responseText);
        const data = JSON.parse(responseText);
        console.log("Parsed data:", data);
        return data;
      } catch (error) {
        console.error("Fetch error:", error);
        alert(`Error fetching data: ${error.message}\n\nURL: ${url}`);
        return null;
      }
    },
    async fetchProjectMap() {
      const url = `${this.$store.state.hostname}/api/v1/projects`;

      try {
        const response = await fetch(url, {
          method: "GET",
          credentials: "include",
          headers: { "content-type": "application/json" },
        });

        if (!response.ok) {
          const errorText = await response.text();
          console.error("Projects fetch error:", errorText);
          throw new Error(`Projects request failed: ${response.status}`);
        }

        const jsondata = await response.json();
        const projects = jsondata?.data?.data || [];
        return projects.reduce((map, project) => {
          if (project?._id && project?.name) {
            map[project._id] = project.name;
          }
          return map;
        }, {});
      } catch (error) {
        console.error("Fetch project map error:", error);
        // Fallback to empty map if project fetch fails
        return {};
      }
    },
    triggerDownload(blob, filename) {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },
    async generateCSV() {
      this.generatingCSV = true;
      try {
        const data = await this.fetchProductData();
        console.log("CSV - Fetched data:", data);

        const products = data?.data || data?.dewars || [];

        if (!Array.isArray(products) || products.length === 0) {
          alert("No product data available");
          return;
        }

        const projectMap = await this.fetchProjectMap();
        const csvExports = buildProductCsvExports(products, { projectMap });
        const stamp = new Date().toISOString().split("T")[0];

        csvExports.forEach(({ name, content }) => {
          if (!content) {
            return;
          }
          const blob = new Blob(["\uFEFF" + content], {
            type: "text/csv;charset=utf-8",
          });
          this.triggerDownload(blob, `product_${name}_${stamp}.csv`);
        });
      } finally {
        this.generatingCSV = false;
      }
    },
    async generateHTML() {
      this.generatingHTML = true;
      try {
        const data = await this.fetchProductData();
        console.log("HTML - Fetched data:", data);

        const products = data?.data || data?.dewars || [];

        if (!Array.isArray(products) || products.length === 0) {
          alert("No product data available");
          return;
        }

        const htmlContent = buildProductHtmlViewer(products, new Date().toLocaleString());
        const stamp = new Date().toISOString().split("T")[0];

        const blob = new Blob([htmlContent], { type: "text/html" });
        this.triggerDownload(blob, `product_data_viewer_${stamp}.html`);
      } finally {
        this.generatingHTML = false;
      }
    },
  },
  data() {
    return {
      createkey: false,
      visible: [],
      showKey: false,
      labKeys: [],
      generatingCSV: false,
      generatingHTML: false,
      selectedKeyIndex: 0,
    };
  },
};
</script>
<style scoped>
.somepadding > div {
  padding: 0.3rem 0.5rem;
}
</style>
